<script setup lang="ts">

import { AppSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { InputPrimary } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalCreateAssignmentTemplate } from '../../../model/assignments/modal-create-assignment-template.hook'

defineOptions({
  name: 'ModalCreateAssignmentTemplate',
})

const {
  refIsOpen,
  refIsLoading,
  refTitle,
  refType,
  refGrade,
  refIsValid,
  typeOptions,
  gradeSelectOptions,
  setTitle,
  closeModal,
  createTemplate,
} = useModalCreateAssignmentTemplate()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    title="Create assignment template"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <div class="modal-create-assignment-template">
      <InputPrimary
        id="assignment-template-title"
        label="Title"
        required
        placeholder="e.g. The Lighthouse Keeper"
        :value="refTitle"
        @update:value="setTitle"
      />

      <AppSelect
        v-model="refType"
        :options="typeOptions"
        label="Type"
        placeholder="Select type"
        required
      />

      <AppSelect
        v-model="refGrade"
        :options="gradeSelectOptions"
        label="Grade"
        placeholder="Select grade"
        required
      />
    </div>

    <template #controls>
      <BtnPrimary
        text="Create"
        color="emerald"
        :disabled="!refIsValid || refIsLoading"
        @click="createTemplate"
      />
      <BtnSecondary
        text="Cancel"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalCreateAssignmentTemplate.scss" />
